// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__sz6jC","error":"Textarea_error__3xyOl","readonly":"Textarea_readonly__VzATk","disabled":"Textarea_disabled__3OM0d"};